module.exports = __webpack_public_path__ + "static/media/blueFish.4f06562a.svg";